export default function(){
    return(
        <div style = {{textAlign: "center"}}>
            <p>Some are used. Some are not. Good luck.</p>
            <a href="https://en.wikipedia.org/wiki/Arnold_Cipher"> Arnold Cipher</a><br/>
            <a href="https://en.wikipedia.org/wiki/ASCII"> ASCII</a><br/>
            <a href="https://en.wikipedia.org/wiki/Bacon%27s_cipher"> Bacon's Cipher</a><br/>
            <a href="https://en.wikipedia.org/wiki/Beale_ciphers"> Beale Cipher</a><br/>
            <a href="https://en.wikipedia.org/wiki/Book_cipher"> Book Cipher</a><br/>
            <a href="https://en.wikipedia.org/wiki/Caesar_cipher"> Caesar Cipher</a><br/>
            <a href="https://en.wikipedia.org/wiki/Hexadecimal"> Hexadecimal</a><br/>
            <a href="https://en.wikipedia.org/wiki/Hill_cipher"> Hill Cipher</a><br/>
            <a href="https://en.wikipedia.org/wiki/Playfair_cipher"> Playfair Cipher</a><br/>
            <a href="https://en.wikipedia.org/wiki/Polybius_square"> Polybius Square</a><br/>
            <a href="https://en.wikipedia.org/wiki/Vigen%C3%A8re_cipher"> Vigen're Cipher</a><br/>       
        </div>
    )
}